import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { siteInfo, testimonials } from "@/mocks/site";

const principles = [
  {
    icon: "ri-radar-line",
    title: "实时跟进",
    desc: "重要话题出现后尽快整理，把时间线与讨论要点一次说清。",
  },
  {
    icon: "ri-scales-3-line",
    title: "客观呈现",
    desc: "只整理已经公开的讨论与反馈，不对仍在发酵的信息下结论。",
  },
  {
    icon: "ri-bookmark-3-line",
    title: "分类清晰",
    desc: "综艺、影视、音乐、品牌各归其位，找自己想看的内容更省时间。",
  },
];

export default function BrandSection() {
  return (
    <section className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-[1.05fr_1fr] gap-8 lg:gap-12 items-start">
          <div>
            <SectionHeading
              eyebrow="ABOUT US"
              title="关于黑料网爆"
              desc={siteInfo.intro}
            />
            <div className="mt-7 space-y-4">
              {principles.map((item) => (
                <div key={item.title} className="flex items-start gap-4">
                  <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-primary-50 text-primary-600">
                    <i className={`${item.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                    <p className="mt-1 text-sm leading-6 text-foreground-600">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            <Link
              to="/about"
              className="mt-7 inline-flex items-center gap-2 rounded-md border border-background-400/70 bg-background-100 px-5 py-3 text-sm font-medium text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解内容原则与团队
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </span>
            </Link>
          </div>

          <div>
            <h3 className="font-heading text-lg font-bold text-foreground-950">网友怎么说</h3>
            <div className="mt-5 space-y-4">
              {testimonials.map((item) => (
                <figure
                  key={item.name}
                  className="rounded-lg border border-background-300/60 bg-background-100 p-5"
                >
                  <div className="flex items-center gap-1 text-accent-500">
                    {[0, 1, 2, 3, 4].map((star) => (
                      <span key={star} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-sm" aria-hidden="true"></i>
                      </span>
                    ))}
                  </div>
                  <blockquote className="mt-3 text-sm leading-7 text-foreground-700">
                    {item.text}
                  </blockquote>
                  <figcaption className="mt-4 flex items-center gap-3 border-t border-background-300/60 pt-4">
                    <span className="w-10 h-10 overflow-hidden rounded-full bg-background-200">
                      <img
                        src={item.avatar}
                        alt={`${item.name} 头像`}
                        className="w-full h-full object-cover object-top"
                      />
                    </span>
                    <span>
                      <span className="block text-sm font-medium text-foreground-900">{item.name}</span>
                      <span className="block text-xs text-foreground-500">{item.role}</span>
                    </span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="md:col-span-2 rounded-lg border border-primary-200 bg-primary-50 p-6 md:p-8">
            <h3 className="font-heading text-xl font-bold text-foreground-950">有线索？欢迎直接告诉我们</h3>
            <p className="mt-2 max-w-xl text-sm leading-7 text-foreground-700">
              如果你掌握了更完整的时间线或现场信息，可以在关于我们页面提交线索。我们会认真核对每一条内容，并在确认后更新相关话题。
            </p>
            <Link
              to="/about"
              className="mt-5 inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-send-plane-line" aria-hidden="true"></i>
              </span>
              提交线索
            </Link>
          </div>
          <div className="rounded-lg border border-background-300/60 bg-background-100 p-6 md:p-8">
            <h3 className="font-heading text-base font-bold text-foreground-950">联系邮箱</h3>
            <p className="mt-3 flex items-center gap-2 text-sm text-foreground-700">
              <span className="w-4 h-4 flex items-center justify-center text-primary-500">
                <i className="ri-mail-line" aria-hidden="true"></i>
              </span>
              {siteInfo.email}
            </p>
            <p className="mt-3 flex items-center gap-2 text-sm text-foreground-700">
              <span className="w-4 h-4 flex items-center justify-center text-primary-500">
                <i className="ri-hand-coin-line" aria-hidden="true"></i>
              </span>
              {siteInfo.cooperation}
            </p>
            <p className="mt-4 text-xs leading-6 text-foreground-500">更新时间：{siteInfo.hours}</p>
          </div>
        </div>
      </div>
    </section>
  );
}